// @ts-strict-ignore
import { JsonObject, JsonProperty } from '@shared/convert/convert-core';

@JsonObject('ArticleTechDataValueVO')
export class ArticleTechDataValueVO {

  @JsonProperty('techDataName', 'String')
  public techDataName: string = undefined;

  @JsonProperty('techDataValue', '[String]')
  public techDataValue: string[] = undefined;
}
